import { yupResolver } from "@hookform/resolvers/yup";
import { PhotoCamera } from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Grid from "@mui/material/Grid";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";
import ImageComponent from "components/ImageComponent/ImageComponent";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  addPropertyPostApi,
  deletePropertyImage,
  getAmenities,
  getCityList,
  getProperty,
  getPropertyType,
  getStateList,
  preSignedUrl,
  propertySaveAsDraft,
  updateProperty,
} from "services/addProperty.service";
import propertyPlaceholder from "../../assets/images/no-property.png";
import { AddPropertySchema } from "./PropertyValidationSchema";

const numWithMax4Decimal = (num) => {
  const number = num > 0 ? Number.parseFloat(num).toFixed(2) : Number(0.0);
  return Number(number);
};
const AddProperty = () => {
  const minDate = useRef(dayjs().add(120, "days"));

  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  const navigate = useNavigate();
  const { propertyId } = useParams();
  const [loading, setLoading] = useState(false);
  const [formLoader, setFormLoader] = useState(false);
  const [propertyType, setPropertyType] = useState([
    {
      propertyTypeId: 1,
      name: "no data found",
    },
  ]);
  const [cityList, setCityList] = useState([
    { cityId: null, name: "Please Select State", stateCode: null },
  ]);

  const [stateList, setStateList] = useState([
    { stateId: null, name: "Please wait...", code: null },
  ]);
  const [deletedImages, setDeletedImages] = useState([]);
  // const [value, setValue] = useState();
  const [uploadImages, setUploadImages] = useState([]);
  const [dividendDate, setDividendDate] = useState(null);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [durationDate, setDurationDate] = useState(() => minDate?.current);
  const [docDetails, setDocDetails] = useState([
    { name: "Use of proceed", url: "" },
    { name: "Risk factors", url: "" },
    { name: "Series overview", url: "" },
    { name: "Offering circular", url: "" },
  ]);
  const [cityListLoader, setCityListLoader] = useState(false);
  const [nullImageList, setNullImageList] = useState([]);
  const [amenitiesList, setAmenitiesList] = useState([
    { name: "No Amenities", amenityId: null },
  ]);
  const [viewPropertyDetails, setViewPropertyDetails] = useState({});
  //pre-signed-url call and store image on aws
  const uploadImageOnAws = async () => {
    let primaryImage = uploadImages.findIndex((img) => img.isPrimary === true);
    primaryImage = `image${primaryImage !== -1 ? primaryImage + 1 : 1}`;
    const resArr = await uploadImages.map(async (img, index) => {
      if (propertyId && !img?.file) return null;
      const imgData = {
        mediaName: `${img.mediaName}`,
        mediaCategory: "Properties",
        mediaType: img?.mediaType,
      };

      return preSignedUrl(imgData)
        .then(async (resp) => {
          const preSignedUrl = resp.data.url;
          const storagePath = resp.data.storagePath;
          try {
            await axios.put(preSignedUrl, img.file, {
              headers: {
                "content-type": img?.mediaType,
                "Access-Control-Allow-Origin": "*",
              },
            });

            return storagePath;
          } catch (error) {
            const { response } = error;
            toast.error(response?.data?.message);
            return false;
          }
        })
        .catch((err) => {
          const { response } = err;
          toast.error(response?.data?.message);
          return false;
        });
    });
    return Promise.all(resArr).then((res) => {
      return { images: res, primaryImage: primaryImage };
    });
  };
  //get today's date
  // const getTodayDate = () => {
  //   let today = new Date();
  //   let dd = today.getDate();
  //   let mm = today.getMonth() + 1;
  //   let yyyy = today.getFullYear();
  //   if (dd < 10) {
  //     dd = '0' + dd;
  //   }
  //   if (mm < 10) {
  //     mm = '0' + mm;
  //   }
  //   today = mm + '/' + dd + '/' + yyyy;
  //   return today;
  // };
  // submit form
  const onSubmit = async (values, isDraft) => {
    try {
      if (!(isDraft === true)) {
        if (Number(values.purchasePrice) < Number(values.addMortageAmount)) {
          toast.error("Mortgage amount should not greater than purchase price");
          return;
        }
        if (docDetails.length > 0) {
          let validate = true;
          docDetails.forEach((doc) => {
            if (doc.url) {
              const pattern =
                /^(https?:\/\/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&\/\/=]*))?$/;
              const isMatch = pattern.test(doc.url);
              if (!isMatch) {
                toast.error("Add valid url in document link", {
                  toastId: "urlNotMatch",
                });
                validate = false;
              }
            }
          });
          if (!validate) return;
        }
        if (uploadImages.length < 4) {
          toast.error("Upload At Least 4 Property Image");
          return;
        }
      }
      setFormLoader(true);
      const uploadResponse = await uploadImageOnAws();
      const getMultiUnit = () => {
        let obj = {};
        if (
          propertyType?.find((val) => val.name === "Multifamily")
            ?.propertyTypeId === Number(getValues("propertyType"))
        ) {
          obj = {
            multiFamilyUnitMix: [
              {
                title: "Studio",
                unitCount: Number(values.unitCount_studio),
                avgSqFt: Number(values.avgSqrFt_studio),
                percentage: Number(values.percentage_studio),
              },
              {
                title: "1Bed",
                unitCount: Number(values.unitCount_1),
                avgSqFt: Number(values.avgSqrFt_1),
                percentage: Number(values.percentage_1),
              },
              {
                title: "2Bed",
                unitCount: Number(values.unitCount_2),
                avgSqFt: Number(values.avgSqrFt_2),
                percentage: Number(values.percentage_2),
              },
              {
                title: "3Bed",
                unitCount: Number(values.unitCount_3),
                avgSqFt: Number(values.avgSqrFt_3),
                percentage: Number(values.percentage_3),
              },
              {
                title: "4Bed",
                unitCount: Number(values.unitCount_studio),
                avgSqFt: Number(values.avgSqrFt_4),
                percentage: Number(values.percentage_4),
              },
              {
                title: "5Bed",
                unitCount: Number(values.unitCount_5),
                avgSqFt: Number(values.avgSqrFt_5),
                percentage: Number(values.percentage_5),
              },
            ],
            multiFamilyTotalUnit:
              Number(values.unitCount_studio) +
              Number(values.unitCount_1) +
              Number(values.unitCount_2) +
              Number(values.unitCount_3) +
              Number(values.unitCount_4) +
              Number(values.unitCount_5),
            multiFamilyUnitOccupied: Number(values.multiFamilyUnitOccupied),
          };
        }
        return obj;
      };
      const getImage = (imagesArr) => {
        let images = {};
        let addedImageCount = 0;
        imagesArr.images.forEach((val, index) => {
          if (val) {
            if (propertyId) {
              images = { ...images, [nullImageList[addedImageCount]]: val };
              addedImageCount++;
            } else {
              images = { ...images, [`image${index + 1}`]: val };
            }
          }
        });
        return images;
      };
      const getDocuments = () => {
        let docArr = [];
        docDetails?.forEach((doc) => {
          if (doc.url) {
            docArr.push({ name: doc.name, url: doc.url });
          }
        });
        return docArr;
      };
      const getPropertyForUpdate = () => {
        if (Boolean(propertyId) && !Boolean(viewPropertyDetails.isDrafted)) {
          return {
            isSecondary: viewPropertyDetails.isSecondary,
            securityId: values.securityId,
          };
        }
        return {};
      };
      const getAmenitiesArray = () => {
        if (values?.amenities?.length > 0) {
          return {
            amenitiesId: values.amenities.map(Number),
          };
        } else
          return {
            amenitiesId: [],
          };
      };

      const bodyData = {
        saveAsDraft: isDraft,
        isRegD: values.isRegD,
        name: values.propertyName,
        address: values.locality,
        bed: Number(values.bedrooms),
        bath: Number(values.bathrooms),
        sqFt: Number(values.propertyArea),
        yearBuild: Number(values.yearOfConstruction),
        totalShare: Number(values.addTotalNoOfShares),
        propertyDesc: values.description,
        minimumPrice: numWithMax4Decimal(values.minimumPurchase),
        rentPerNight: numWithMax4Decimal(values.rentPerNight || 0),
        rentPerMonth: numWithMax4Decimal(values.averageMonthlyRental || 0),
        managementPartnerDesc: values.brokerDescription,
        marketDesc: values.marketDescription,
        latitude: values.latitude,
        zipCode: values.zipCode,
        streetAddress: values.streetAddress,
        longitude: values.longitude,
        typeId: Number(values.propertyType),
        tag: values.tag || null,
        duration: values.duration || null,
        ...getPropertyForUpdate(),
        perSharePrice: numWithMax4Decimal(values.addIPOSharePrice),
        mortgageAmount: numWithMax4Decimal(values.addMortageAmount),
        mortgageInterestRate: Number(values.addMortageInterestRate),
        equityRaised: numWithMax4Decimal(values.equityRaised),
        purchasePrice: numWithMax4Decimal(values.purchasePrice),
        improvements: numWithMax4Decimal(values.addImprovements),
        cohCosts: numWithMax4Decimal(values.addClosingsOfferingsAndHoldingCost),
        sourcingFees: numWithMax4Decimal(values.addRealbricksSourcingFees),
        aumFees: numWithMax4Decimal(values.addRealBricksAUMFee),
        // propertyManagementFees: numWithMax4Decimal(
        //   values.addPropertyManagementFees
        // ),
        propertyStatus: values.propertyStatus,
        dividendDate: values.expectedFirstDividend || null,
        avgRentTime: Number(values.avgRentTime),
        dividendYield: Number(values.firstDividendYield),
        occupancyRate: Number(values.occupancyRate),
        documents: getDocuments(),
        cityId: Number(values.city),
        stateId: Number(values.state),
        primaryImage: uploadResponse?.primaryImage,
        ...getAmenitiesArray(),
        avgAppreciation: Number(values.averageAppreciation),
        avgDividend: Number(values.averageDividend),
        lowAppreciation: Number(values.lowAppreciation),
        lowDividend: Number(values.lowDividend),
        highAppreciation: Number(values.highAppreciation),
        highDividend: Number(values.highDividend),
        brokerName: values.brokerName || null,
        brokerDetail: values.brokerDetails || null,
        aumGrossRentFees: Number(values?.addRealBricksAUMFeeGrossRent) || 0,
        aumPurchasePriceFees: Number(values.addRealBricksAUMFeePurchase),
        // propertyMgmtGrossRentFees: Number(values.addPropertyManagementFees),
        propertyMgmtFeesMax: Number(values.propertyMgmtFeesMax) || 0,
        propertyMgmtFeesMin: Number(values?.propertyMgmtFeesMin) || 0,
        marketName: values.marketName,
        managementPartnerName: values.managementPartnerName,
        ...getMultiUnit(),
        ...getImage(uploadResponse),
      };
      if (isDraft === true) {
        let body = {};
        for (let property in bodyData) {
          if (Boolean(bodyData[property]) || bodyData[property] === false) {
            if (
              property === "primaryImage" &&
              uploadResponse.images.length === 0
            ) {
            } else {
              body = { ...body, [property]: bodyData[property] };
            }
          }
        }

        if (propertyId) {
          Object.keys(bodyData).forEach((key) => {
            if (!bodyData[key] && bodyData[key] !== 0) {
              delete bodyData[key];
            }
          });
          bodyData.isRegD = values.isRegD;
          handleUpdateProperty(propertyId, body);
        } else {
          handleSaveAsDraftProperty(body);
        }
        return;
      }
      propertyId
        ? handleUpdateProperty(propertyId, bodyData)
        : handleAddPropertyApi(bodyData);
    } catch (error) {
      // console.log(error, "err364");
      toast.error(error || "Something went wrong");
      setFormLoader(false);
    }
  };
  //handler function
  const handleTag = (e, checked) => {
    if (checked) {
      setValue("tag", e.target.value, { shouldDirty: true });
    } else {
      setValue("tag", "");
    }
  };
  const handleUploadImages = async (e) => {
    const newImages = e.currentTarget.files;
    const fileCount = newImages.length + uploadImages.length;
    if (fileCount > 9) {
      toast.error("Maximum 9 images allowed");
      return;
    }
    const urlArr = [];
    for (let i = 0; i < newImages.length; i++) {
      const url = URL.createObjectURL(newImages[i]);
      const mediaName = newImages[i].name;
      const mediaType = newImages[i]?.name?.split(".")?.pop()?.toLowerCase();
      const isPrimary = uploadImages.length === 0 && i === 0 ? true : false;
      const file = newImages[i];
      if (!uploadImages.find((val) => val.mediaName === newImages[i].name)) {
        urlArr.push({
          mediaName: mediaName,
          mediaType: mediaType,
          url: url,
          file: file,
          isPrimary: isPrimary,
        });
      } else {
        toast.error(newImages[i].name + " is already uploaded");
      }
    }
    setUploadImages((prevState) => [...prevState, ...urlArr]);
  };
  const deleteImage = (val) => {
    const { url } = val;
    setDeleteLoader(url);
    if (propertyId && !Boolean(val.file?.name)) {
      setDeletedImages([...deletedImages, { ...val }]);
      setNullImageList([...nullImageList, val.imageNumber]);
    }
    setUploadImages(() => {
      return uploadImages.filter((img) => url !== img.url);
    });
    setDeleteLoader(false);
  };
  const setPrimaryImage = (val) => {
    setUploadImages(() => {
      return uploadImages?.map((img) => {
        if (img.url === val) {
          return { ...img, isPrimary: true };
        }
        return { ...img, isPrimary: false };
      });
    });
  };
  const showErrorMessage = (errorMessage) => {
    return (
      <div style={{ fontSize: "small", color: "red" }}>
        {errorMessage.message}
      </div>
    );
  };
  const handleDatePicker = (date, duration) => {
    // const { $D, $M, $y } = date;
    const twoFigure = (val) => (val < 10 ? `0${val}` : val);
    const day = twoFigure(date?.$D);
    const month = twoFigure(date?.$M + 1);
    const year = date?.$y;
    if (duration) {
      setDurationDate(`${month}/${day}/${year}`);
      setValue("duration", `${month}/${day}/${year}`);
    } else {
      setDividendDate(`${month}/${day}/${year}`);
      setValue("expectedFirstDividend", `${month}/${day}/${year}`);
    }
    return `${month}/${day}/${year}`;
  };
  const docHandler = (val, index) => {
    const { name, value } = val;
    const arr = [...docDetails];
    arr[index] = {
      ...arr[index],
      [name]: value,
    };
    setDocDetails([...arr]);
  };
  const handleCityList = (val) => {
    const stateCode = stateList.find((state) => state.stateId === val)?.code;
    if (stateCode) {
      fetchCityList({ stateCode });
    }
  };
  const handlePropertyTypeValidation = (e) => {
    const val = propertyType?.find(
      (val) => Number(val.propertyTypeId) === Number(e)
    );
    return val?.name;
  };
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    setValue,
    reset,
    getValues,
    watch,
  } = useForm({
    mode: "onTouched",
    resolver: yupResolver(
      AddPropertySchema(
        handlePropertyTypeValidation,
        Boolean(
          propertyId &&
          !viewPropertyDetails?.isDrafted &&
          Number(viewPropertyDetails?.fundedPercentage) >= 100
        )
      )
    ),
  });
  const stateRegister = register("state");
  const firstDividendDateReg = register("expectedFirstDividend");
  const durationDateReg = register("duration");
  //API Integration
  const fetchPropertyType = async (body) => {
    try {
      const propertyTypeRes = await getPropertyType(body);
      if (!propertyTypeRes.isError) {
        setPropertyType(propertyTypeRes.data.propertyTypes);
      } else {
        toast.error(propertyTypeRes?.message);
      }
    } catch (error) {
      const { response } = error;
      toast.error(response?.data?.message);
    }
  };
  const fetchAmenities = async () => {
    try {
      const amenitiesList = await getAmenities();
      if (!amenitiesList.isError) {
        setAmenitiesList(amenitiesList.data.amenities);
      } else {
        toast.error(amenitiesList?.message);
      }
    } catch (error) {
      const { response } = error;
      toast.error(response?.data?.message);
    }
  };
  const handleAddPropertyApi = async (body) => {
    setFormLoader(true);
    try {
      delete body.saveAsDraft
      const addPropertyResp = await addPropertyPostApi(body);
      const addPropertyData = addPropertyResp.data;
      if (!addPropertyResp.isError) {
        toast.success(addPropertyData?.message);
        navigate("/properties");
        reset();
      } else {
        toast.error(addPropertyResp?.message);
      }
    } catch (error) {
      const { response } = error;
      response?.data?.message && toast.error(response?.data?.message);
    }
    setFormLoader(false);
  };
  const getPropertyForView = async (id) => {
    setLoading(true);
    try {
      const res = await getProperty(id, source.token);
      if (!res.isError) {
        await setAllValueToFields(res.data);
        await setViewPropertyDetails(res.data);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      const { response } = error;
      toast.error(response?.data?.message);
    }
    setLoading(false);
  };
  const fetchStateList = async () => {
    try {
      const propertyTypeRes = await getStateList();
      if (!propertyTypeRes.isError) {
        setStateList(propertyTypeRes.data.states);
      } else {
        toast.error(propertyTypeRes?.message);
      }
    } catch (error) {
      const { response } = error;
      toast.error(response?.data?.message);
    }
  };
  const fetchCityList = async (query) => {
    setCityListLoader(true);
    try {
      const propertyTypeRes = await getCityList(query);
      if (!propertyTypeRes.isError) {
        propertyTypeRes.data.cities.length > 0
          ? setCityList(propertyTypeRes.data.cities)
          : setCityList([
            { cityId: null, name: "Please Select State", stateCode: null },
          ]);
      } else {
        toast.error(propertyTypeRes?.message);
      }
    } catch (error) {
      const { response } = error;
      toast.error(response?.data?.message);
    }
    setCityListLoader(false);
  };
  const handleUpdateProperty = async (id, body) => {
    setFormLoader(true);
    try {
      const resArr = await deletedImages?.map(
        (val) =>
          val?.imageNumber &&
          deleteImageAPI({
            propertyImage: val.imageNumber,
          })
      );
      const res = await Promise.all(resArr).then(async (res) => {
        const response = await updateProperty(id, body);
        return response;
      });
      reset();
      if (!res.isError) {
        toast.success(res?.message);
        navigate("/properties");
        reset();
      } else {
        toast.error(res?.message);
        setFormLoader(false);
      }
    } catch (error) {
      const { response } = error;
      response?.data?.message && toast.error(response?.data?.message);
      setFormLoader(false);
    }
    setFormLoader(false);
  };
  const deleteImageAPI = async (body) => {
    try {
      const res = await deletePropertyImage(propertyId, body);
      if (!res.isError) {
        // toast.success(res?.message);
        // setUploadImages(() => {
        //   return uploadImages.filter((img) => val.url !== img.url);
        // });
      }
    } catch (error) {
      const { response } = error;
      setDeleteLoader(false);
      toast.error(response?.data?.message);
    }
  };
  const handleSaveAsDraftProperty = async (body) => {
    setFormLoader(true);
    try {
      const res = await propertySaveAsDraft(body);
      if (!res.isError) {
        toast.success(res?.data?.message);
        navigate("/properties");
        reset();
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      const { response } = error;
      response?.data?.message && toast.error(response?.data?.message);
    }
    setFormLoader(false);
  };
  const handleSaveAsDraft = (e) => {
    e.preventDefault();
    onSubmit(getValues(), true);
  };
  //function for update property page
  const setAllValueToFields = (val) => {
    //unit mix array
    const studioArr = val.status?.multiFamilyUnitMix?.find(
      (val) => val.title === "Studio"
    );
    const oneBedArr = val.status?.multiFamilyUnitMix?.find(
      (val) => val.title === "1Bed"
    );
    const twoBedArr = val.status?.multiFamilyUnitMix?.find(
      (val) => val.title === "2Bed"
    );
    const threeBedArr = val.status?.multiFamilyUnitMix?.find(
      (val) => val.title === "3Bed"
    );
    const fourBedArr = val.status?.multiFamilyUnitMix?.find(
      (val) => val.title === "4Bed"
    );
    const fiveBedArr = val.status?.multiFamilyUnitMix?.find(
      (val) => val.title === "5Bed"
    );
    // set image to state
    const getImg = () => {
      const arr = [];
      const nullImageArray = [];
      const primaryImg = val.images.primaryImage;
      for (const property in val.images) {
        if (val.images[property] && property !== "primaryImage") {
          arr.push({
            url: val.images[property],
            isPrimary: property === primaryImg,
            imageNumber: property,
          });
        } else if (
          val.images[property] === null &&
          property !== "primaryImage"
        ) {
          nullImageArray.push(property);
        }
      }
      setNullImageList(nullImageArray);
      return arr;
    };
    //set amenities
    const setAmenities = () => {
      return val.amenities?.map((val) => Number(val.id));
    };
    //
    setValue("propertyName", val.name);
    setValue("isRegD", val.isRegD);
    setValue("bedrooms", val.bed || null);
    setValue("bathrooms", val.bath || null);
    setValue("propertyArea", val.sqFt || null);
    setValue("yearOfConstruction", val.yearBuild || null);
    setValue("description", val.propertyDesc);
    setValue("propertyType", val?.propertyType?.id);
    setValue("city", val?.city?.id || null);
    setValue("state", val?.state?.id || null);
    setValue("avgRentTime", val.status?.avgRentTime || "");
    setValue("rentPerNight", val.rentPerNight || "");
    setValue("purchasePrice", val.finance?.purchasePrice || "");
    setValue("latitude", val.latitude);
    setValue("streetAddress", val.streetAddress);
    setValue("zipCode", val.zipCode);
    setValue("longitude", val.longitude);
    setValue("averageMonthlyRental", val.rentPerMonth || "");
    setValue("amenities", setAmenities());
    setValue("propertyStatus", val.status.propertyStatus);
    setValue("occupancyRate", val.status.occupancyRate || null);
    setValue("firstDividendYield", val.status.dividendYield || null);
    setValue("duration", val.duration || null);
    minDate.current = val.duration;
    setValue("equityRaised", val.finance?.equityRaised || 0);
    setValue("brokerDescription", val.managementPartnerDesc);
    setValue("marketDescription", val.marketDesc);
    setValue("addMortageAmount", val.finance?.mortgageAmount || 0);
    setValue(
      "addMortageInterestRate",
      val.finance?.mortgageInterestRate || 0
    );
    setValue("addIPOSharePrice", val.finance?.perSharePrice || null);
    setValue("addTotalNoOfShares", val.totalShare || null);
    setValue("addImprovements", val.finance?.improvements || 0);
    setValue(
      "addClosingsOfferingsAndHoldingCost",
      val.finance?.cohCosts || null
    );
    setValue("addRealbricksSourcingFees", val.finance?.sourcingFees || null);
    setValue("addRealBricksAUMFee", val.finance?.aumFees || null);
    // setValue(
    //   'addPropertyManagementFees',
    //   val.finance?.propertyMgmtGrossRentFees
    // );
    setValue("tag", val.tag);
    setValue("listPropertyOnSecondaryMarket", val.isSecondary);
    setValue("averageAppreciation", val.finance?.avgAppreciation || null);
    setValue("averageDividend", val.finance?.avgDividend || null);
    setValue("lowAppreciation", val.finance?.lowAppreciation || null);
    setValue("lowDividend", val.finance?.lowDividend || null);
    setValue("highAppreciation", val.finance?.highAppreciation || null);
    setValue("highDividend", val.finance?.highDividend || null);
    setValue(
      "addRealBricksAUMFeePurchase",
      val.finance?.aumPurchasePriceFees || null
    );
    setValue(
      "addRealBricksAUMFeeGrossRent",
      val.finance?.aumGrossRentFees || null
    );
    setValue("leverage", val.finance?.leverage);
    setValue("minimumPurchase", val.minimumPrice || null);
    setValue("unitCount_1", oneBedArr?.unitCount);
    setValue("unitCount_2", twoBedArr?.unitCount);
    setValue("unitCount_3", threeBedArr?.unitCount);
    setValue("unitCount_4", fourBedArr?.unitCount);
    setValue("unitCount_5", fiveBedArr?.unitCount);
    setValue("unitCount_studio", studioArr?.unitCount);
    setValue("percentage_1", oneBedArr?.percentage);
    setValue("percentage_2", twoBedArr?.percentage);
    setValue("percentage_3", threeBedArr?.percentage);
    setValue("percentage_4", fourBedArr?.percentage);
    setValue("percentage_5", fiveBedArr?.percentage);
    setValue("percentage_studio", studioArr?.percentage);
    setValue("avgSqrFt_1", oneBedArr?.avgSqFt);
    setValue("avgSqrFt_2", twoBedArr?.avgSqFt);
    setValue("avgSqrFt_3", threeBedArr?.avgSqFt);
    setValue("avgSqrFt_4", fourBedArr?.avgSqFt);
    setValue("avgSqrFt_5", fiveBedArr?.avgSqFt);
    setValue("avgSqrFt_studio", studioArr?.avgSqFt);
    setValue("brokerDetails", val.brokerDetail);
    setValue("brokerName", val.brokerName);
    setValue("locality", val.address);
    setValue("marketName", val?.marketName ?? "");
    setValue("expectedFirstDividend", val.status?.dividendDate || null);
    setValue("multiFamilyTotalUnit", val.status?.multiFamilyTotalUnit);
    setValue("multiFamilyUnitOccupied", val.status?.multiFamilyUnitOccupied);
    setValue("managementPartnerName", val?.managementPartnerName ?? "");
    setValue("propertyMgmtFeesMax", val.finance?.propertyMgmtFeesMax || "");
    setValue("propertyMgmtFeesMin", val.finance?.propertyMgmtFeesMin || "");
    setValue("securityId", val.securityId);
    setUploadImages(getImg());
    setDocDetails(
      docDetails?.map((doc, index) => {
        const findDoc = val.documents.find((val) => val.name === doc.name);
        if (findDoc) {
          return { name: findDoc.name, url: findDoc.url };
        } else {
          return { name: doc.name, url: doc.url };
        }
      })
    );
    setDurationDate(val.duration || null);
    setDividendDate(val.status?.dividendDate || null);
  };
  //use effect
  useEffect(() => {
    propertyId && getPropertyForView(propertyId);
    fetchPropertyType();
    fetchAmenities();
    fetchStateList();
    return () => source.cancel("Component got unmounted");
  }, []);
  useEffect(() => {
    if (Boolean(propertyId) && Boolean(viewPropertyDetails?.state?.id)) {
      handleCityList(viewPropertyDetails.state.id);
    }
  }, [viewPropertyDetails, stateList]);
  useEffect(() => {
    const unloadCallback = (event) => {
      event.preventDefault();
      event.returnValue = "";
      return "";
    };
    isDirty
      ? window.addEventListener("beforeunload", unloadCallback)
      : window.removeEventListener("beforeunload", unloadCallback);
    return () => window.removeEventListener("beforeunload", unloadCallback);
  }, [isDirty]);  

  return (
    <>
      <MDButton
        color="secondary"
        variant="gradient"
        startIcon={<ArrowBackIcon />}
        sx={{ margin: "12px" }}
        size="large"
        onClick={() => {
          if (isDirty) {
            if (window.confirm("Changes that you made will not be saved")) {
              navigate("/properties");
            }
          } else {
            navigate("/properties");
          }
        }}
      >
        Go Back
      </MDButton>
      <Card sx={{ marginTop: "48px", padding: "0 30px" }}>
        <MDBox
          mt={-3}
          mx={-1}
          py={3}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
        >
          <MDTypography variant="h6" color="white">
            {propertyId
              ? viewPropertyDetails?.isDrafted
                ? "Drafted Property"
                : "Update Property"
              : "Add Property"}
          </MDTypography>
        </MDBox>
        {propertyId && !viewPropertyDetails.name ? (
          <MDBox bgColor="light" px={3} py={2} mx={-1} my={2} borderRadius="lg">
            <MDTypography fontWeight="bold">
              {loading ? (
                <MDBox textAlign="center">
                  <CircularProgress color="inherit" size={30} />
                </MDBox>
              ) : (
                "No Property Found"
              )}
            </MDTypography>
          </MDBox>
        ) : (
          <form
              onSubmit={handleSubmit(() => {
              onSubmit(getValues(), false)
            })}
            autocomplete="off"
          >
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={formLoader}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <MDBox
              bgColor="light"
              px={3}
              py={2}
              mx={-1}
              my={2}
              borderRadius="lg"
            >
              <MDTypography fontWeight="bold">Basic Details</MDTypography>
            </MDBox>
            <Grid container mb={3} spacing={3}>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="propertyName"
                  variant="outlined"
                  label="Property Name"
                  {...register("propertyName")}
                  fullWidth
                />
                {errors.propertyName
                  ? showErrorMessage(errors.propertyName)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <FormControl fullWidth>
                  <InputLabel id="propertyType">
                    Select Property Type
                  </InputLabel>
                  <Select
                    name="propertyType"
                    labelId="propertyType"
                    id="property"
                    MenuProps={{
                      style: {
                        maxHeight: "400px",
                      },
                    }}
                    defaultValue={
                      propertyId ? viewPropertyDetails?.propertyType?.id : null
                    }
                    sx={{ height: "44px" }}
                    label="Select Property Type"
                    // onChange={(e) => setPropertyType(e.target.value)}
                    {...register("propertyType")}
                  >
                    {propertyType?.map((type, index) => {
                      return (
                        <MenuItem
                          value={type.propertyTypeId}
                          key={type.propertyTypeId}
                          selected={index === 1}
                        >
                          {type.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {errors.propertyType
                    ? showErrorMessage(errors.propertyType)
                    : null}
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDButton
                  variant="gradient"
                  color="info"
                  endIcon={<PhotoCamera />}
                  component="label"
                >
                  Upload Images
                  <input
                    hidden
                    accept="image/*"
                    multiple
                    type="file"
                    name="propertyImages"
                    {...register("propertyImages")}
                    onChange={(e) => handleUploadImages(e)}
                  />
                </MDButton>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              {uploadImages?.map((image, i) => (
                <Grid item xs={12} lg={6} xl={4} xxxl={3} key={i}>
                  <Card sx={{ height : '300px'}}>
                    <ImageComponent
                      imgStyles={{ margin: "0", aspectRatio: "16 / 9", minHeight : '212px'}}
                      imageUrl={image?.url}
                      spinnerSize={30}
                      fallbackImg={propertyPlaceholder}
                    />
                    <CardContent>
                      <Stack
                        mt={2}
                        direction="row"
                        justifyContent="space-between"
                        spacing={1}
                      >
                        {image.isPrimary ? (
                          <MDButton
                            variant="gradient"
                            color="secondary"
                            fullWidth
                          >
                            Primary Image
                          </MDButton>
                        ) : (
                          <>
                            <MDButton
                              variant="gradient"
                              color="info"
                              fullWidth
                              onClick={() => setPrimaryImage(image.url)}
                            >
                              Set Primary
                            </MDButton>
                            <MDButton
                              variant="gradient"
                              color="error"
                              fullWidth
                              onClick={() => deleteImage(image)}
                              isLoading={deleteLoader === image.url}
                              disabled={deleteLoader === image.url}
                            >
                              Delete
                            </MDButton>
                          </>
                        )}
                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
              {errors.propertyImages
                ? showErrorMessage(errors.propertyImages)
                : null}
            </Grid>
            <Grid container sx={{ marginTop: "0px" }} spacing={2}>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="bedrooms"
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  label="Bedrooms"
                  fullWidth
                  {...register("bedrooms")}
                />
                {errors.bedrooms ? showErrorMessage(errors.bedrooms) : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="bathrooms"
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  label="Bathrooms"
                  fullWidth
                  {...register("bathrooms")}
                />
                {errors.bathrooms ? showErrorMessage(errors.bathrooms) : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="propertyArea"
                  label="Area (in square feet)"
                  fullWidth
                  {...register("propertyArea")}
                />
                {errors.propertyArea
                  ? showErrorMessage(errors.propertyArea)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="yearOfConstruction"
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  label="Year of construction"
                  fullWidth
                  {...register("yearOfConstruction")}
                />
                {errors.yearOfConstruction
                  ? showErrorMessage(errors.yearOfConstruction)
                  : null}
              </Grid>
              {Boolean(watch("propertyType")) && (
                <>
                  {propertyType?.find(
                    (val) =>
                      val.name === "Vacation rental" ||
                      val.name === "Vacation Rental"
                  )?.propertyTypeId === Number(watch("propertyType")) ||
                    watch("propertyType") === 38 ? (
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="rentPerNight"
                        label="Rent Per Night"
                        fullWidth
                        {...register("rentPerNight")}
                      />
                      {errors.rentPerNight
                        ? showErrorMessage(errors.rentPerNight)
                        : null}
                    </Grid>
                  ) : (
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="averageMonthlyRental"
                        label="Average Monthly Rent"
                        fullWidth
                        {...register("averageMonthlyRental")}
                      />
                      {errors.averageMonthlyRental
                        ? showErrorMessage(errors.averageMonthlyRental)
                        : null}
                    </Grid>
                  )}
                </>
              )}
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="minimumPurchase"
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  label="Minimum Purchase"
                  fullWidth
                  {...register("minimumPurchase")}
                />
                {errors.minimumPurchase
                  ? showErrorMessage(errors.minimumPurchase)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <LocalizationProvider
                  sx={{
                    width: "100%",
                  }}
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    name="duration"
                    label="Duration"
                    sx={{ width: "100%" }}
                    minDate={minDate.current}
                    disablePast={true}
                    {...durationDateReg}
                    onChange={(val) => {
                      durationDateReg.onChange({
                        target: {
                          name: "duration",
                          value: handleDatePicker(val, true),
                        },
                      });
                      handleDatePicker(val, true);
                    }}
                    inputFormat="MM/DD/YYYY"
                    value={durationDate}
                    renderInput={(params) => (
                      <MDInput
                        {...params}
                        helperText={null}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                    )}
                    fullWidth
                  />
                  {errors.duration ? showErrorMessage(errors.duration) : null}
                </LocalizationProvider>
              </Grid>
              <Box width="100%" />
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  multiline
                  label="Street Address"
                  fullWidth
                  name="streetAddress"
                  {...register("streetAddress")}
                />
                {errors.streetAddress
                  ? showErrorMessage(errors.streetAddress)
                  : null}
              </Grid>
              <Box width="100%" />
              <Grid item xs={12} lg={6} xl={3}>
                <FormControl fullWidth>
                  <InputLabel id="state">Select State</InputLabel>
                  <Select
                    name="state"
                    sx={{ height: "44px" }}
                    label="Select State"
                    fullWidth
                    MenuProps={{
                      style: {
                        maxHeight: "400px",
                      },
                    }}
                    defaultValue={
                      propertyId ? viewPropertyDetails?.state?.id : null
                    }
                    {...stateRegister}
                    onChange={(e) => {
                      stateRegister.onChange(e);
                      handleCityList(e.target.value);
                    }}
                  >
                    {stateList?.map((state) => {
                      return (
                        <MenuItem value={state.stateId} key={state?.stateId}>
                          {state.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {errors?.state ? showErrorMessage(errors?.state) : null}
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <FormControl fullWidth>
                  <InputLabel id="propertyType">Select City</InputLabel>
                  <Select
                    name="city"
                    sx={{ height: "44px" }}
                    label="Select City"
                    fullWidth
                    MenuProps={{
                      style: {
                        maxHeight: "400px",
                      },
                    }}
                    defaultValue={
                      propertyId ? viewPropertyDetails?.city?.id : null
                    }
                    {...register("city")}
                  >
                    {cityListLoader ? (
                      <MenuItem>Loading...</MenuItem>
                    ) : (
                      cityList?.map((city) => {
                        return (
                          <MenuItem value={city.cityId} key={city?.cityId}>
                            {city.name}
                          </MenuItem>
                        );
                      })
                    )}
                  </Select>
                  {errors.city ? showErrorMessage(errors.city) : null}
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  multiline
                  label="Zip Code"
                  fullWidth
                  name="zipCode"
                  {...register("zipCode")}
                />
                {errors.zipCode ? showErrorMessage(errors.zipCode) : null}
              </Grid>

              <Box width="100%" />
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  multiline
                  label="Latitude"
                  fullWidth
                  name="latitude"
                  {...register("latitude")}
                />
                {errors.latitude ? showErrorMessage(errors.latitude) : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  multiline
                  label="Longitude"
                  fullWidth
                  name="longitude"
                  {...register("longitude")}
                />
                {errors.longitude ? showErrorMessage(errors.longitude) : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <a
                  href={"https://www.google.com/maps/place/United+States/"}
                  target="_blank"
                  rel="noreferrer"
                >
                  Find on Google Maps
                </a>
              </Grid>
            </Grid>
            <Divider sx={{ margin: "48px 0" }} />
            <MDBox
              bgColor="light"
              px={3}
              py={2}
              mx={-1}
              my={2}
              borderRadius="lg"
            >
              <MDTypography fontWeight="bold">About Property</MDTypography>
            </MDBox>
            <MDInput
              name="description"
              multiline
              rows={7}
              label="Description"
              fullWidth
              {...register("description")}
            />
            {errors.description ? showErrorMessage(errors.description) : null}
            <MDBox
              bgColor="light"
              px={3}
              py={2}
              mx={-1}
              my={2}
              borderRadius="lg"
            >
              <MDTypography fontWeight="bold">Amenities</MDTypography>
            </MDBox>
            <Grid container space={2}>
              {amenitiesList?.map((amenity) => (
                <Grid item xs={6} lg={4} xxl={3}>
                  <FormControlLabel
                    key={amenity.amenityId}
                    value={Number(amenity.amenityId)}
                    name="amenities"
                    control={
                      <Checkbox
                        checked={
                          Array.isArray(watch("amenities")) &&
                          Boolean(
                            watch("amenities")?.find(
                              (val) => Number(val) === Number(amenity.amenityId)
                            )
                          )
                        }
                        {...register("amenities")}
                      />
                    }
                    label={amenity.name}
                  />
                </Grid>
              ))}
              {errors.amenities ? showErrorMessage(errors.amenities) : null}
            </Grid>
            {propertyType?.find((val) => val.name === "Multifamily")
              ?.propertyTypeId === Number(watch("propertyType")) && (
                <>
                  <MDBox
                    bgColor="light"
                    px={3}
                    py={2}
                    mx={-1}
                    my={2}
                    borderRadius="lg"
                  >
                    <MDTypography fontWeight="bold">Unit Mix</MDTypography>
                  </MDBox>
                  <Grid container mt={-2} mb={2} spacing={2}>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="studio"
                        multiline
                        value="Studio"
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="unitCount"
                        multiline
                        label="Unit Count"
                        fullWidth
                        {...register("unitCount_studio")}
                      />
                      {errors.unitCount_studio
                        ? showErrorMessage(errors.unitCount_studio)
                        : null}
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="avgSqrFt"
                        multiline
                        label="Avg sq. ft"
                        fullWidth
                        {...register("avgSqrFt_studio")}
                      />
                      {errors.avgSqrFt_studio
                        ? showErrorMessage(errors.avgSqrFt_studio)
                        : null}
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="percentage"
                        multiline
                        label="Percentage"
                        fullWidth
                        {...register("percentage_studio")}
                      />
                      {errors.percentage_studio
                        ? showErrorMessage(errors.percentage_studio)
                        : null}
                    </Grid>
                  </Grid>
                  <Grid container mt={-2} mb={2} spacing={2}>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="oneBed"
                        multiline
                        fullWidth
                        value={"1 Bed"}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="unitCount"
                        multiline
                        label="Unit Count"
                        fullWidth
                        {...register("unitCount_1")}
                      />
                      {errors.unitCount_1
                        ? showErrorMessage(errors.unitCount_1)
                        : null}
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="avgSqrFt"
                        multiline
                        label="Avg sq. ft"
                        fullWidth
                        {...register("avgSqrFt_1")}
                      />
                      {errors.avgSqrFt_1
                        ? showErrorMessage(errors.avgSqrFt_1)
                        : null}
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="percentage"
                        multiline
                        label="Percentage"
                        fullWidth
                        {...register("percentage_1")}
                      />
                      {errors.percentage_1
                        ? showErrorMessage(errors.percentage_1)
                        : null}
                    </Grid>
                  </Grid>
                  <Grid container mt={-2} mb={2} spacing={2}>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="twoBed"
                        multiline
                        fullWidth
                        value={"2 Bed"}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="unitCount"
                        multiline
                        label="Unit Count"
                        fullWidth
                        {...register("unitCount_2")}
                      />
                      {errors.unitCount_2
                        ? showErrorMessage(errors.unitCount_2)
                        : null}
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="avgSqrFt"
                        multiline
                        label="Avg sq. ft"
                        fullWidth
                        {...register("avgSqrFt_2")}
                      />
                      {errors.avgSqrFt_2
                        ? showErrorMessage(errors.avgSqrFt_2)
                        : null}
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="percentage"
                        multiline
                        label="Percentage"
                        fullWidth
                        {...register("percentage_2")}
                      />
                      {errors.percentage_2
                        ? showErrorMessage(errors.percentage_2)
                        : null}
                    </Grid>
                  </Grid>
                  <Grid container mt={-2} mb={2} spacing={2}>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="threeBed"
                        multiline
                        value={"3 Bed"}
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="unitCount"
                        multiline
                        label="Unit Count"
                        fullWidth
                        {...register("unitCount_3")}
                      />
                      {errors.unitCount_3
                        ? showErrorMessage(errors.unitCount_3)
                        : null}
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="avgSqrFt"
                        multiline
                        label="Avg sq. ft"
                        fullWidth
                        {...register("avgSqrFt_3")}
                      />
                      {errors.avgSqrFt_3
                        ? showErrorMessage(errors.avgSqrFt_3)
                        : null}
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="percentage"
                        multiline
                        label="Percentage"
                        fullWidth
                        {...register("percentage_3")}
                      />
                      {errors.percentage_3
                        ? showErrorMessage(errors.percentage_3)
                        : null}
                    </Grid>
                  </Grid>
                  <Grid container mt={-2} mb={2} spacing={2}>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="fourBed"
                        multiline
                        value={"4 Bed"}
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="unitCount"
                        multiline
                        label="Unit Count"
                        fullWidth
                        {...register("unitCount_4")}
                      />
                      {errors.unitCount_4
                        ? showErrorMessage(errors.unitCount_4)
                        : null}
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="avgSqrFt"
                        multiline
                        label="Avg sq. ft"
                        fullWidth
                        {...register("avgSqrFt_4")}
                      />
                      {errors.avgSqrFt_4
                        ? showErrorMessage(errors.avgSqrFt_4)
                        : null}
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="percentage"
                        multiline
                        label="Percentage"
                        fullWidth
                        {...register("percentage_4")}
                      />
                      {errors.percentage_4
                        ? showErrorMessage(errors.percentage_4)
                        : null}
                    </Grid>
                  </Grid>
                  <Grid container mt={-2} mb={2} spacing={2}>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="fiveBed"
                        multiline
                        value={"5 Bed"}
                        fullWidth
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="unitCount"
                        multiline
                        label="Unit Count"
                        fullWidth
                        {...register("unitCount_5")}
                      />
                      {errors.unitCount_5
                        ? showErrorMessage(errors.unitCount_5)
                        : null}
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="avgSqrFt"
                        multiline
                        label="Avg sq. ft"
                        fullWidth
                        {...register("avgSqrFt_5")}
                      />
                      {errors.avgSqrFt_5
                        ? showErrorMessage(errors.avgSqrFt_5)
                        : null}
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="percentage"
                        multiline
                        label="Percentage"
                        fullWidth
                        {...register("percentage_5")}
                      />
                      {errors.percentage_5
                        ? showErrorMessage(errors.percentage_5)
                        : null}
                    </Grid>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="multiFamilyUnitOccupied"
                        multiline
                        label="Multi Family Unit Occupied"
                        fullWidth
                        {...register("multiFamilyUnitOccupied")}
                      />
                      {errors.multiFamilyUnitOccupied
                        ? showErrorMessage(errors.multiFamilyUnitOccupied)
                        : null}
                    </Grid>
                  </Grid>
                </>
              )}

            <Divider sx={{ margin: "48px 0" }} />
            <MDBox
              bgColor="light"
              px={3}
              py={2}
              mx={-1}
              my={2}
              borderRadius="lg"
            >
              <MDTypography fontWeight="bold">Management</MDTypography>
            </MDBox>
            <FormControl
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <MDTypography
                id="property-status"
                sx={{ fontSize: "16px", fontWeight: "700", color: "black" }}
              >
                Property Status:
              </MDTypography>
              <RadioGroup
                row
                aria-labelledby="property-status"
                name="propertyStatus"
                defaultValue={
                  propertyId && viewPropertyDetails?.status?.propertyStatus
                }
              >
                <FormControlLabel
                  {...register("propertyStatus")}
                  value="rented"
                  control={<Radio />}
                  label="Rented"
                />
                <FormControlLabel
                  {...register("propertyStatus")}
                  value="rentReady"
                  control={<Radio />}
                  label="Rent Ready"
                />
                <FormControlLabel
                  {...register("propertyStatus")}
                  value="marketedForRent"
                  control={<Radio />}
                  label="Marketed For Rent"
                />
              </RadioGroup>
              {errors.propertyStatus
                ? showErrorMessage(errors.propertyStatus)
                : null}
            </FormControl>
            <Grid container spacing={2} mt={0}>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="occupancyRate"
                  label="Occupancy Rate"
                  fullWidth
                  {...register("occupancyRate")}
                />
                {errors.occupancyRate
                  ? showErrorMessage(errors.occupancyRate)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="avgRentTime"
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  label="Average Time to Rent (days)"
                  fullWidth
                  {...register("avgRentTime")}
                />
                {errors.avgRentTime
                  ? showErrorMessage(errors.avgRentTime)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="firstDividendYield"
                  label="Dividend Yield (%)"
                  fullWidth
                  {...register("firstDividendYield")}
                />
                {errors.firstDividendYield
                  ? showErrorMessage(errors.firstDividendYield)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <LocalizationProvider
                  sx={{
                    width: "100%",
                  }}
                  dateAdapter={AdapterDayjs}
                >
                  <DatePicker
                    name="expectedFirstDividend"
                    label="Dividend Date"
                    sx={{ width: "100%" }}
                    disablePast={true}
                    {...firstDividendDateReg}
                    onChange={(val) => {
                      firstDividendDateReg.onChange({
                        target: {
                          name: "expectedFirstDividend",
                          value: handleDatePicker(val, false),
                        },
                      });
                      handleDatePicker(val, false);
                    }}
                    inputFormat="MM/DD/YYYY"
                    value={dividendDate}
                    renderInput={(params) => (
                      <MDInput
                        {...params}
                        helperText={null}
                        onKeyDown={(e) => e.preventDefault()}
                        error={!!errors?.expectedFirstDividend}
                      />
                    )}
                    fullWidth
                  />
                  {errors.expectedFirstDividend
                    ? showErrorMessage(errors.expectedFirstDividend)
                    : null}
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="managementPartnerName"
                  label="Management Partner Name"
                  fullWidth
                  {...register("managementPartnerName")}
                />
                {errors.managementPartnerName
                  ? showErrorMessage(errors.managementPartnerName)
                  : null}
              </Grid>
            </Grid>
            <MDInput
              name="brokerDescription"
              sx={{ marginTop: "16px" }}
              multiline
              rows={7}
              label="Management Partner Description"
              fullWidth
              {...register("brokerDescription")}
            />
            {errors.brokerDescription
              ? showErrorMessage(errors.brokerDescription)
              : null}
            {(propertyType?.find(
              (val) =>
                val.name === "Vacation rental" || val.name === "Vacation Rental"
            )?.propertyTypeId === Number(watch("propertyType")) ||
              watch("propertyType") === 38) && (
                <>
                  <Grid container spacing={2} mt={0}>
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        name="brokerName"
                        label="Broker name"
                        fullWidth
                        {...register("brokerName")}
                      />
                      {errors.brokerName
                        ? showErrorMessage(errors.brokerName)
                        : null}
                    </Grid>
                  </Grid>
                  <MDInput
                    name="brokerDetails"
                    sx={{ marginTop: "16px" }}
                    multiline
                    rows={7}
                    label="Broker Details"
                    fullWidth
                    {...register("brokerDetails")}
                  />
                  {errors.brokerDetails
                    ? showErrorMessage(errors.brokerDetails)
                    : null}
                </>
              )}
            <Divider sx={{ margin: "48px 0" }} />
            <MDBox
              bgColor="light"
              px={3}
              py={2}
              mx={-1}
              my={2}
              borderRadius="lg"
            >
              <MDTypography fontWeight="bold">The Market</MDTypography>
            </MDBox>
            <Grid container spacing={2} mt={0}>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="marketName"
                  label="Market Name"
                  fullWidth
                  {...register("marketName")}
                />
                {errors.marketName ? showErrorMessage(errors.marketName) : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="locality"
                  label="Locality"
                  fullWidth
                  {...register("locality")}
                />
                {errors.locality ? showErrorMessage(errors.locality) : null}
              </Grid>
            </Grid>
            <MDInput
              name="marketDescription"
              sx={{ marginTop: "16px" }}
              multiline
              rows={7}
              label="Market Description"
              fullWidth
              {...register("marketDescription")}
            />
            {errors.marketDescription
              ? showErrorMessage(errors.marketDescription)
              : null}
            <Divider sx={{ margin: "48px 0" }} />
            <MDBox
              bgColor="light"
              px={3}
              py={2}
              mx={-1}
              my={2}
              borderRadius="lg"
            >
              <MDTypography fontWeight="bold">Performance</MDTypography>
            </MDBox>
            <Grid container mt={-2} mb={2} spacing={2}>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="low"
                  multiline
                  // label="Low"
                  fullWidth
                  value={"Low"}
                  disabled
                />
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="lowAppreciation"
                  multiline
                  label="Appreciation"
                  fullWidth
                  {...register("lowAppreciation")}
                />
                {errors.lowAppreciation
                  ? showErrorMessage(errors.lowAppreciation)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="lowDividend"
                  multiline
                  label="Dividend"
                  fullWidth
                  {...register("lowDividend")}
                />
                {errors.lowDividend
                  ? showErrorMessage(errors.lowDividend)
                  : null}
              </Grid>
            </Grid>
            <Grid container mt={-2} mb={2} spacing={2}>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="average"
                  multiline
                  // label="Average"
                  fullWidth
                  disabled
                  value={"Average"}
                />
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="averageAppreciation"
                  multiline
                  label="Appreciation"
                  fullWidth
                  {...register("averageAppreciation")}
                />
                {errors.averageAppreciation
                  ? showErrorMessage(errors.averageAppreciation)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="averageDividend"
                  multiline
                  label="Dividend"
                  fullWidth
                  {...register("averageDividend")}
                />
                {errors.averageDividend
                  ? showErrorMessage(errors.averageDividend)
                  : null}
              </Grid>
            </Grid>
            <Grid container mt={-2} mb={2} spacing={2}>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="high"
                  multiline
                  // label="High"
                  fullWidth
                  value={"High"}
                  disabled
                />
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="highAppreciation"
                  multiline
                  label="Appreciation"
                  fullWidth
                  {...register("highAppreciation")}
                />
                {errors.highAppreciation
                  ? showErrorMessage(errors.highAppreciation)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="highDividend"
                  multiline
                  label="Dividend"
                  fullWidth
                  {...register("highDividend")}
                />
                {errors.highDividend
                  ? showErrorMessage(errors.highDividend)
                  : null}
              </Grid>
            </Grid>
            <Divider sx={{ margin: "48px 0" }} />
            <MDBox
              bgColor="light"
              px={3}
              py={2}
              mx={-1}
              my={2}
              borderRadius="lg"
            >
              <MDTypography fontWeight="bold">Offering Details</MDTypography>
            </MDBox>
            <Grid container mt={-2} mb={5} spacing={2}>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="addMortageAmount"
                  multiline
                  label="Mortgage Amount"
                  fullWidth
                  {...register("addMortageAmount")}
                />
                {errors.addMortageAmount
                  ? showErrorMessage(errors.addMortageAmount)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="addMortageInterestRate"
                  multiline
                  label="Mortgage Interest Rate"
                  fullWidth
                  {...register("addMortageInterestRate")}
                />
                {errors.addMortageInterestRate
                  ? showErrorMessage(errors.addMortageInterestRate)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="addIPOSharePrice"
                  multiline
                  label="IPO share Price"
                  fullWidth
                  {...register("addIPOSharePrice")}
                />
                {errors.addIPOSharePrice
                  ? showErrorMessage(errors.addIPOSharePrice)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="addTotalNoOfShares"
                  multiline
                  label="Total no of shares"
                  fullWidth
                  {...register("addTotalNoOfShares")}
                />
                {errors.addTotalNoOfShares
                  ? showErrorMessage(errors.addTotalNoOfShares)
                  : null}
              </Grid>
              {propertyId && !viewPropertyDetails.isDrafted && (
                <>
                  <Grid item xs={12} lg={6} xl={3}>
                    <MDInput
                      name="leverage"
                      multiline
                      label="Leverage"
                      fullWidth
                      {...register("leverage")}
                      disabled
                    />
                    {errors.leverage ? showErrorMessage(errors.leverage) : null}
                  </Grid>
                </>
              )}
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="equityRaised"
                  multiline
                  label="Equity Raised"
                  fullWidth
                  // disabled
                  {...register("equityRaised")}
                />
                {errors.equityRaised
                  ? showErrorMessage(errors.equityRaised)
                  : null}
              </Grid>
            </Grid>
            <MDBox
              bgColor="light"
              px={3}
              py={2}
              mx={-1}
              my={2}
              borderRadius="lg"
            >
              <MDTypography fontWeight="bold">Offering Expenses</MDTypography>
            </MDBox>
            <Grid container mt={-2} mb={5} spacing={2}>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="purchasePrice"
                  label="Purchase Price"
                  fullWidth
                  {...register("purchasePrice")}
                />
                {errors.purchasePrice
                  ? showErrorMessage(errors.purchasePrice)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="addImprovements"
                  multiline
                  label="Improvements"
                  fullWidth
                  {...register("addImprovements")}
                />
                {errors.addImprovements
                  ? showErrorMessage(errors.addImprovements)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="addClosingsOfferingsAndHoldingCost"
                  multiline
                  label="closings offerings and holding cost"
                  fullWidth
                  {...register("addClosingsOfferingsAndHoldingCost")}
                />
                {errors.addClosingsOfferingsAndHoldingCost
                  ? showErrorMessage(errors.addClosingsOfferingsAndHoldingCost)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="addRealbricksSourcingFees"
                  multiline
                  label="Realbricks sourcing fees"
                  fullWidth
                  {...register("addRealbricksSourcingFees")}
                />
                {errors.addRealbricksSourcingFees
                  ? showErrorMessage(errors.addRealbricksSourcingFees)
                  : null}
              </Grid>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="addRealBricksAUMFee"
                  multiline
                  label="AUM fee"
                  fullWidth
                  {...register("addRealBricksAUMFee")}
                />
                {errors.addRealBricksAUMFee
                  ? showErrorMessage(errors.addRealBricksAUMFee)
                  : null}
              </Grid>
            </Grid>
            <MDBox
              bgColor="light"
              px={3}
              py={2}
              mx={-1}
              my={2}
              borderRadius="lg"
            >
              <MDTypography fontWeight="bold">Recurring Fees</MDTypography>
            </MDBox>
            <Grid container mt={-2} mb={5} spacing={2}>
              <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="addRealBricksAUMFeePurchase"
                  multiline
                  label="AUM fee (%)"
                  fullWidth
                  {...register("addRealBricksAUMFeePurchase")}
                />
                {errors.addRealBricksAUMFeePurchase
                  ? showErrorMessage(errors.addRealBricksAUMFeePurchase)
                  : null}
              </Grid>
              {/* NOTE: Commented for future reference due to CR #91 */}
              {/* <Grid item xs={12} lg={6} xl={3}>
                <MDInput
                  name="addRealBricksAUMFeeGrossRent"
                  multiline
                  label="AUM fee - Gross Rent (%)"
                  fullWidth
                  {...register("addRealBricksAUMFeeGrossRent")}
                />
                {errors.addRealBricksAUMFeeGrossRent
                  ? showErrorMessage(errors.addRealBricksAUMFeeGrossRent)
                  : null}
              </Grid> */}
              {/* NOTE: Commented for future reference due to CR #91 */}
              {/* {(propertyType?.find(
                (val) =>
                  val.name === "Vacation rental" ||
                  val.name === "Vacation Rental"
              )?.propertyTypeId === Number(watch("propertyType")) ||
                watch("propertyType") === 38) && (
                  <> */}
                    <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        multiline
                        label="Property Management Fees"
                        fullWidth
                        name="propertyMgmtFeesMin"
                        {...register("propertyMgmtFeesMin")}
                      />
                      {errors.propertyMgmtFeesMin
                        ? showErrorMessage(errors.propertyMgmtFeesMin)
                        : null}
                    </Grid>
                    {/* NOTE: Commented for future reference due to CR #91 */}
                    {/* <Grid item xs={12} lg={6} xl={3}>
                      <MDInput
                        multiline
                        label="Property Management Fees - Max (%)"
                        fullWidth
                        name="propertyMgmtFeesMax"
                        {...register("propertyMgmtFeesMax")}
                      />
                      {errors.propertyMgmtFeesMax
                        ? showErrorMessage(errors.propertyMgmtFeesMax)
                        : null}
                    </Grid> */}
                  {/* </>
                )} */}
            </Grid>
            <MDBox
              bgColor="light"
              px={3}
              py={2}
              mx={-1}
              my={2}
              borderRadius="lg"
            >
              <MDTypography fontWeight="bold">Documents</MDTypography>
            </MDBox>
            <Grid container mt={-2} spacing={2}>
              {docDetails.map((val, index) => {
                return (
                  <>
                    <Grid item xs={8} md={4}>
                      <MDInput
                        multiline
                        fullWidth
                        name="name"
                        value={docDetails[index].name}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <MDInput
                        multiline
                        label="Document Link"
                        fullWidth
                        name="url"
                        value={docDetails[index].url}
                        onChange={(e) => docHandler(e.target, index)}
                      />
                    </Grid>
                  </>
                );
              })}
            </Grid>
            <Divider sx={{ margin: "30px 0" }} />
            <MDBox
              bgColor="light"
              px={3}
              py={2}
              mx={-1}
              my={2}
              borderRadius="lg"
            >
              <MDTypography fontWeight="bold">Select Tag</MDTypography>
            </MDBox>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                // name="row-radio-buttons-group"
                name="tag"
                defaultValue={propertyId && viewPropertyDetails?.tag}
              >
                <FormControlLabel
                  value="new"
                  control={
                    <Checkbox
                      checked={Boolean(watch("tag") === "new")}
                      onChange={handleTag}
                    />
                  }
                  label="New"
                />
                <FormControlLabel
                  value="trending"
                  control={
                    <Checkbox
                      checked={Boolean(watch("tag") === "trending")}
                      onChange={handleTag}
                    />
                  }
                  label="Trending"
                />
                <FormControlLabel
                  value="comingSoon"
                  control={
                    <Checkbox
                      checked={Boolean(watch("tag") === "comingSoon")}
                      onChange={handleTag}
                    />
                  }
                  label="Coming Soon"
                />
              </RadioGroup>
              {errors.tag ? showErrorMessage(errors.tag) : null}
            </FormControl>
            {/* RegD Property */}
            <Divider sx={{ margin: "20px 0" }} />
            <MDBox
              bgColor="light"
              px={3}
              py={2}
              mx={-1}
              my={2}
              borderRadius="lg"
            >
              <MDTypography fontWeight="bold">Select Property Type</MDTypography>
            </MDBox>
            <FormControlLabel
              {...register("isRegD")}
              control={
                <Checkbox
                  checked={Boolean(watch("isRegD"))} />
              }
              label="IsRegD"
            />
            <Divider sx={{ margin: "48px 0" }} />
            {propertyId &&
              !viewPropertyDetails?.isDrafted &&
              Number(viewPropertyDetails?.fundedPercentage) >= 100 && (
                <>
                  <MDBox
                    bgColor="light"
                    px={3}
                    py={2}
                    mx={-1}
                    my={2}
                    borderRadius="lg"
                  >
                    <MDTypography fontWeight="bold">
                      Security Id From NorthCap
                    </MDTypography>
                  </MDBox>
                  <Grid container spacing={2} mt={0}>
                    <Grid item xs={12} lg={6} xl={4}>
                      <MDInput
                        name="securityId"
                        label="Security Id"
                        fullWidth
                        {...register("securityId")}
                      />
                      {errors.securityId
                        ? showErrorMessage(errors.securityId)
                        : null}
                    </Grid>
                  </Grid>
                  <Divider sx={{ margin: "48px 0" }} />
                </>
              )}
            {propertyId && !viewPropertyDetails.isDrafted && (
              <>
                <MDBox
                  bgColor="light"
                  px={3}
                  py={2}
                  mx={-1}
                  my={2}
                  borderRadius="lg"
                >
                  <MDTypography fontWeight="bold">
                    Secondary Market
                  </MDTypography>
                </MDBox>
                <FormControlLabel
                  name="listPropertyOnSecondaryMarket"
                  control={
                    <Checkbox
                      defaultChecked={Boolean(
                        watch("listPropertyOnSecondaryMarket")
                      )}
                      {...register("listPropertyOnSecondaryMarket")}
                      disabled={true}
                    />
                  }
                  label="List Property on Secondary market"
                />
                <Divider sx={{ margin: "48px 0 24px" }} />
              </>
            )}
            <Stack
              my={3}
              direction="row"
              justifyContent="space-between"
              spacing={1}
            >
              {!propertyId || viewPropertyDetails?.isDrafted ? (
                <MDButton
                  type="gradient"
                  color="secondary"
                  fullWidth
                  onClick={handleSaveAsDraft}
                  disabled={!isDirty}
                >
                  Save as Draft
                </MDButton>
              ) : (
                <></>
              )}

              <MDButton
                type="submit"
                color="info"
                fullWidth
                disabled={formLoader}
              >
                {propertyId && !viewPropertyDetails?.isDrafted
                  ? "Update"
                  : "Publish"}
              </MDButton>
            </Stack>
          </form>
        )}
      </Card>
    </>
  );
};

export default AddProperty;
